import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './projects.css';
import bonsai from '../../assets/images/bonsai.png';
import butterfly from '../../assets/images/butterfly.png';
import harvest from '../../assets/images/harvest.png';


const Projects = () => {
  return (
    <div className='projects' id='projects'>
      <Container>
        <h5>PORTFOLIO</h5>
        <h3>
          Each project is a distinct and individual piece of software
          development.
        </h3>
        <Row className='project__wrapper'>
          <Col lg='6' md='12'>
            <div className='project__image'>
              <a
                href='https://my-bonsai-garden.netlify.app/'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img className='social' src={bonsai} alt='Bonsai website' />
              </a>
            </div>
          </Col>
          <Col className='project__details' lg='6' md='12'>
            <h5>Bonsai Garden</h5>
            <p>
            The React Bonsai Garden is a user-friendly web app that allows bonsai enthusiasts to create and manage their digital bonsai collection. Users can add, view, edit, and delete bonsai entries. The app also offers valuable tips for bonsai maintenance, catering to both beginners and experienced enthusiasts alike.
            </p>
            <Row className='tech__group'>
              <Col className=' backend d-flex align-items-center'>
                <h5>Backend</h5>
                <ul>
                  <li>Bcrypt</li>
                  <li>Cors</li>
                  <li>Dotenv</li>
                </ul>
              </Col>
              <Col className='frontend d-flex align-items-center'>
                <h5>Frontend</h5>
                <ul>
                  <li>Bootstrap</li>
                  <li>React</li>
                  <li>React Dom</li>
                  <li>React Router Dom</li>
                  <li>React Scripts</li>
                  <li>Reactstrap</li>
                </ul>
              </Col>
              <Col className='project__links'>
                <a
                  href='https://github.com/JosephDSmith/phase-2-project'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {' '}
                  Code <i className='ri-github-fill'></i>
                </a>
                <a
                  href='https://youtu.be/d6vAozT5yQ4'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Live Demo <i className='ri-live-fill'></i>
                </a>
                <a
                  href='https://my-bonsai-garden.netlify.app/'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Website <i class="ri-pages-fill"></i>
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className='project__wrapper'>
          <Col className='project__details' lg='6' md='12'>
            <h5>Butterfly Garden</h5>
            <p>
            The Butterfly Garden app is a dynamic web application that combines the power of React, Python, and Flask to create a delightful user experience. Enthusiasts and nature lovers can explore a virtual butterfly garden, admiring the graceful flutter of butterflies and the beauty of various plants.

The app's interactive features enable users to actively participate in the garden's growth. Users can add new butterfly and plant entries, enriching the garden's diversity and charm. For added personalization, they can edit or delete the butterflies they've created, enhancing their sense of ownership and connection with the virtual ecosystem.

With a secure authentication system, the app ensures that users have control over their contributions, fostering a sense of responsibility and nurturing a thriving online community. The Butterfly Garden app is a harmonious blend of technology and nature, offering a sanctuary for users to immerse themselves in the enchanting world of butterflies and plants.
            </p>
            <Row className='tech__group'>
              <Col className='backend d-flex align-items-center'>
                <h5>Backend</h5>
                <ul>
                  <li>SQL</li>
                  <li>SQLAlchemy</li>
                  <li>Flask</li>
                  <li>Python</li>
                </ul>
              </Col>
              <Col className='frontend d-flex align-items-center'>
                <h5>Frontend</h5>
                <ul>
                  <li>CSS</li>
                  <li>React</li>
                  <li>React Dom</li>
                  <li>React Router Dom</li>
                  <li>React Scripts</li>
                  <li>Fontawesome</li>
                </ul>
              </Col>
              <Col className='project__links'>
                <a
                  href='https://github.com/JosephDSmith/phase-4-project'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {' '}
                  Code <i className='ri-github-fill'></i>
                </a>
                <a
                  href='https://youtu.be/ylOOzc4l_ac'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Live Demo <i className='ri-live-fill'></i>
                </a>
                <a
                  href='https://butterfly-garden-app.onrender.com/'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Website <i class="ri-pages-fill"></i>
                </a>
              </Col>
            </Row>
          </Col>
          <Col lg='6' md='12'>
            <div className='project__image'>
              <a
                href='https://butterfly-garden-app.onrender.com/'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img
                  className='tour'
                  src={butterfly}
                  alt='sunrise website'
                />
              </a>
            </div>
          </Col>
        </Row>
        <Row className='project__wrapper'>
          <Col lg='6' md='12'>
            <div className='project__image'>
              <a
                href='https://grocery-store-app.onrender.com/'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img className='sunrise' src={harvest} alt='Bonsai website' />
              </a>
            </div>
          </Col>
          <Col className='project__details' lg='6' md='12'>
            <h5>Harvest Market</h5>
            <p>
            The Harvest Market App is a web application designed to connect farmers and consumers, providing a platform for buying and selling fresh, locally grown produce. Whether you're a farmer looking to showcase your harvest or a consumer seeking high-quality, farm-fresh products, this app brings the market to your fingertips.
            </p>
            <Row className='tech__group'>
              <Col className=' backend d-flex align-items-center'>
                <h5>Backend</h5>
                <ul>
                  <li>Bcrypt</li>
                  <li>Cors</li>
                  <li>Dotenv</li>
                  <li>Stripe</li>
                  <li>Flask</li>
                  <li>Python</li>
                </ul>
              </Col>
              <Col className='frontend d-flex align-items-center'>
                <h5>Frontend</h5>
                <ul>
                  <li>Bootstrap</li>
                  <li>React</li>
                  <li>React Dom</li>
                  <li>React Router Dom</li>
                  <li>React Scripts</li>
                  <li>Reactstrap</li>
                </ul>
              </Col>
              <Col className='project__links'>
                <a
                  href='https://github.com/JosephDSmith/phase-5-project'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {' '}
                  Code <i className='ri-github-fill'></i>
                </a>
                <a
                  href='https://youtu.be/vOZr2Za7-2Q'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Live Demo <i className='ri-live-fill'></i>
                </a>
                <a
                  href='https://grocery-store-app.onrender.com/'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Website <i class="ri-pages-fill"></i>
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Projects;
